import { useEffect, useState } from "react";
import { ArrowLeft, Megaphone, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import AICampaignGenerator from "@/components/sales/AICampaignGenerator";
import { CampaignManager } from "@/components/sales/CampaignManager";
import { SequencesDialog } from "@/components/sales/SequencesDialog";

export default function Campaigns() {
  const navigate = useNavigate();
  const { orgId } = useAuth();
  const [leads, setLeads] = useState<any[]>([]);
  const [aiCampaignOpen, setAiCampaignOpen] = useState(false);
  const [sequencesOpen, setSequencesOpen] = useState(false);

  const loadLeads = async () => {
    if (!orgId) return;
    const { data } = await supabase
      .from("leads")
      .select("*")
      .eq("org_id", orgId)
      .order("created_at", { ascending: false });
    setLeads(data || []);
  };

  useEffect(() => {
    void loadLeads();
  }, [orgId]);

  return (
    <div className="container mx-auto space-y-6 px-6 py-8">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <Button variant="ghost" className="mb-3 px-0" onClick={() => navigate("/sales-hub")}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Sales Hub
          </Button>
          <h1 className="flex items-center gap-3 text-3xl font-bold tracking-normal">
            <Megaphone className="h-8 w-8 text-primary" />
            Campaigns
          </h1>
          <p className="mt-2 text-muted-foreground">Create, approve, launch, pause, and audit outreach campaigns.</p>
        </div>
        <Button onClick={() => setAiCampaignOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          New Campaign
        </Button>
      </div>

      <CampaignManager
        leads={leads}
        onCreateCampaign={() => setAiCampaignOpen(true)}
        onOpenSequences={() => setSequencesOpen(true)}
        onRefreshParent={loadLeads}
      />

      <AICampaignGenerator open={aiCampaignOpen} onOpenChange={setAiCampaignOpen} onCampaignCreated={loadLeads} />
      <SequencesDialog open={sequencesOpen} onOpenChange={setSequencesOpen} />
    </div>
  );
}
